import React from 'react';
import { useTranslation } from 'react-i18next';


const Footer = ()=>{
    const { t, i18n } = useTranslation();
    return(
        <div className='text-center bg-exp'>
            <div>
                <div className='py-4'>
                  <div>
                    <a href='terms&condition' className='terms-condition'> {t('footer.termsandcondition')} </a>
                  </div>
                </div>
            </div>
             
        </div>

    );

}

export default Footer;